import { apiClient } from '@/utils/api-client';

// Adoption is derived from live state, so it is accurate for all history.
// Behaviour is counted from user_events and therefore only covers the period
// since tracking shipped — `tracking_since` is what the UI says so about.
export interface MemoryAdoption {
  orgs_with_memory_on: number;
  users_with_memory_on: number;
  eligible_users: number;
  adoption_rate: number;
}

export interface MemoryBehaviour {
  opted_in: number;
  opted_out: number;
  intro_dismissed: number;
  profile_edited: number;
  all_deleted: number;
  pill_opened: number;
  manage_opened: number;
  memory_used_conversations: number;
}

export interface MemoryRetention {
  churned: number;
  median_days_held: number | null;
  still_on_median_days: number | null;
}

export interface MemoryStats {
  window_from: string;
  window_to: string;
  window_days: number;
  tracking_since: string | null;
  adoption: MemoryAdoption;
  behaviour: MemoryBehaviour;
  retention: MemoryRetention;
}

export const memoryStatsService = {
  async getStats(from?: string, to?: string): Promise<MemoryStats> {
    const qs = new URLSearchParams();
    if (from) qs.set('from', from);
    if (to) qs.set('to', to);
    const suffix = qs.toString() ? `?${qs}` : '';
    return apiClient.get(`/api/admin/kaiya_memory_stats${suffix}`);
  },
};
